import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  binanceWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  rabbyWallet,
  safeWallet,
  talismanWallet,
  trustWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import type { Chain } from 'viem';
import { http, createConfig, fallback } from 'wagmi';

import localConfig from 'config';
import type { ChainId } from 'types';
import { chains } from '../chains';
import { WALLET_CONNECT_PROJECT_ID } from '../constants';

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        binanceWallet,
        okxWallet,
        trustWallet,
        walletConnectWallet,
        injectedWallet,
        talismanWallet,
        rabbyWallet,
        metaMaskWallet,
        safeWallet,
      ],
    },
  ],
  { appName: 'Forge', projectId: WALLET_CONNECT_PROJECT_ID },
);

const config = createConfig({
  chains: chains as [Chain, ...Chain[]],
  connectors,
  transports: chains.reduce((acc, chain) => {
    const urls = localConfig.rpcUrls[chain.id as ChainId];
    const transports = urls.map((url) => http(url));
    const isDevNetwork =
      localConfig.network === 'local' || localConfig.network === 'bittensor_testnet';

    return {
      ...acc,
      [chain.id]: fallback(
        isDevNetwork
          ? transports
          : [
              ...transports,
              // Add public RPC Node as a last resort solution
              http(),
            ],
        // `rank: true` makes viem health-check each transport on `interval` and
        // promote whichever is faster, instead of only failing over on hard errors.
        // Matters for endpoints that go "slow but not dead" (e.g. nodies under load).
        // Enabled only on dev networks: production fallback ends in an unauthenticated
        // `http()` that we don't want preferred over our dedicated/paid RPCs.
        isDevNetwork ? { rank: { interval: 60_000 } } : undefined,
      ),
    };
  }, {}),
  batch: {
    multicall: {
      wait: 500,
    },
  },
});

export default config;
